import type { CourseStatus } from '@openclassrooms/sdk-web';

import { HelperResult } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type ChapterContentParams = {
  courseId: number;
  chapterId: number;
  queryParams?: {
    status?: CourseStatus;
  };
};

const { useGet: useChapterContent } = getCRUDHooks({
  entityName: 'chapterContent',
  get: ({ courseId, chapterId, queryParams }: ChapterContentParams): HelperResult<string> =>
    clientApi
      .getOCClient()
      .helpers.learningContent.chapters.getContent(courseId, chapterId, queryParams),
});

// eslint-disable-next-line import/prefer-default-export
export { useChapterContent };
